import BrandIcon from "../../IconsCode/BrandIcon";
import ChannelIcon from "../../IconsCode/ChannelIcon";
import FreeContentIcon from "../../IconsCode/FreeContentIcon";
import UserIcon from "../../IconsCode/UserIcon";
import UsersIcon from "../../IconsCode/UsersIcon";

function ImageSideMenu({ activeTab, num }) {
    return (
        <>
            {num === 0 ?
                <ChannelIcon
                    width={40}
                    height={40}
                    fill={activeTab === num ? "#fff" : "#4355B9"}
                />
                // <img
                //     src={activeTab === num ? "/image/icon/sideMenu/channelManagment.png" : "/image/icon/sideMenu/channelManagment2.png"}
                //     className="w-9 mr-5"
                // />
                :
                num === 1 ?
                    <FreeContentIcon
                        width={40}
                        height={40}
                        fill={activeTab === num ? "#fff" : "#4355B9"}
                    />
                    // <img
                    //     src={activeTab === num ? "/image/icon/sideMenu/contentFreeWhite.png" : "/image/icon/sideMenu/contentFreeGray.png"}
                    //     className="w-9 mr-5"
                    // />
                    :
                    num === 2 ?
                        <UsersIcon
                            width={40}
                            height={40}
                            fill={activeTab === num ? "#fff" : "#4355B9"}
                        />
                        :
                        num === 3 ?
                            <UserIcon
                                width={40}
                                height={40}
                                fill={activeTab === num ? "#fff" : "#4355B9"}
                            />
                            :
                            num === 4 ?
                                <BrandIcon
                                    width={40}
                                    height={40}
                                    fill={activeTab === num ? "#fff" : "#4355B9"}
                                />
                                : null}
        </>
    )
}
export default ImageSideMenu;